import script from "./StudentAssignmentsView.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentAssignmentsView.vue?vue&type=script&setup=true&lang=js"

import "./StudentAssignmentsView.vue?vue&type=style&index=0&id=37ce7e84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37ce7e84"]])

export default __exports__